.boxHeader {
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--spacing-m);
  padding: var(--spacing-l);
  border-bottom: 1px solid;
  border-color: var(--brand-grey-100);
  border-color: light-dark(var(--brand-grey-100), #333);
  min-height: 107px; /* set min height to keep header from jumping when action items aren't present */
}
